/**
 * Day quantities from the leave API are JSON numbers that may be fractional
 * (half days, 2.5-day accruals); show them as sent, never rounded to whole
 * days. Null means "no fixed allowance" and is returned as null, never 0.
 */
export function formatDays(value) {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? String(number) : String(value);
}
